import React, { useEffect } from "react";
import { useTwitterContext } from "../TwitterContext";
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from "react-router-dom";

const UserInfo = ({ info }) => {
  const { accessToken, curUser, updateTweetList } = useTwitterContext();
  const [ followed, setFollowed ] = React.useState(false);
  const { loginWithRedirect } = useAuth0();
  const [ user, setUser ] = React.useState(info);
  const navigate = useNavigate();
  
  async function JumpToProfile() {
    navigate(`/profile/${user.id}`);
  }

  const FollowText = () => {
    if (user === null || user.followers === undefined) {
      return <p className="follow-text">0 followers</p>;
    }
    return (
      <p className="follow-text">{user.followers.length} followers</p>
    );
  };

  useEffect(() => {
    async function getFollowed() {
      const curUserId = Number(curUser.id);
      if (user.followers.some((follow) => follow.follower.id === curUserId)) {
        setFollowed(true);
      }
      else {
        setFollowed(false);
      }
    }
    if (user && curUser && curUser.id !== user.id) {
      getFollowed();
    }
  }, [user, followed, setFollowed, curUser]);

  const FollowButton = () => {
    if (curUser === null || curUser === undefined) {
      return null;
    }
    const curUserId = Number(curUser.id);
    if (user.id === curUserId) {
      return null;
    } else if (followed) {
      return (
        <button className="unfollow-button" onClick={ () => HandleFollowButtonClick() }>
          UnFollow
        </button>
      );
    }
    return (
      <button className="follow-button" onClick={ () => HandleFollowButtonClick() }>
        Follow
      </button>
    );
  }

  async function HandleFollowButtonClick() {
    if (curUser === null) {
      loginWithRedirect();
    }
    const curUserId = Number(curUser.id);
    async function Follow() {
      const data = await fetch(`${process.env.REACT_APP_API_URL}/follows`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
          follower: curUser.id,
          following: user.id,
        }),
      });
      const result = await data.json();
    }
    async function UnFollow() {
      const data = await fetch(`${process.env.REACT_APP_API_URL}/follows/${curUserId}/${user.id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const result = await data.json();
    }
    if (followed) {
      await UnFollow();
    } else {
      await Follow();
    }
    updateTweetList();
  };

  if (user) {
    return (
    <div className="user-info">
      <div className="user-info-left" onClick={JumpToProfile}>
        <img src={user.avatar} className="avatar" alt={user.name} loading="lazy"/>
        <div>
          <p className="user-name">{user.name}</p>
          <FollowText />
        </div>
      </div>
      <FollowButton />
    </div>
    );
  }
  return null; // or any other fallback if needed
};

export default UserInfo;